import React from 'react';
import {
  LINE_ITEM_INITIAL_PAYMENT,
  LINE_ITEM_INITIAL_PAYMENT_PROVIDER,
  LINE_ITEM_PROVIDER_COMMISSION,
  LINE_ITEM_UNITS,
} from '../../util/types';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import css from './ExtraDurationCharges.css';
import { FormattedMessage } from 'react-intl';

const { Money } = sdkTypes;

const ExtraDurationCharges = ({ transaction, isPriceDecreasedForModification, intl }) => {
  if (!transaction) return null;

  const initialPaymentLineItem =
    transaction &&
    transaction.attributes.lineItems.find(
      item => item.code === LINE_ITEM_INITIAL_PAYMENT && !item.reversal
    );
    const initialPayment = transaction && transaction.attributes.protectedData.initialPayment;

  const modifyTxTotal = transaction.attributes.lineItems.reduce((acc, curr) => {
    const excludedLineItems = [
      LINE_ITEM_INITIAL_PAYMENT,
      LINE_ITEM_INITIAL_PAYMENT_PROVIDER,
      LINE_ITEM_PROVIDER_COMMISSION,
    ];

    if (!excludedLineItems.includes(curr.code)) {
      acc += curr.lineTotal.amount;
    }

    return acc;
  }, 0);

  const payinTotal = transaction.attributes.payinTotal;

  // Calculate the total price from line items (excluding initial payment)
  const totalPriceFromLineItems = transaction.attributes.lineItems.reduce((acc, curr) => {
    const excludedLineItems = [
      LINE_ITEM_INITIAL_PAYMENT,
      LINE_ITEM_INITIAL_PAYMENT_PROVIDER,
      LINE_ITEM_PROVIDER_COMMISSION,
    ];

    // Check if this is a trip price line item that should be excluded when units exist
    const isTripPriceLineItem = curr.code === 'line-item/trip-price-regular-days' || 
                               curr.code === 'line-item/trip-price-peak-days' ||
                               curr.code === 'line-item/trip-price-regular-hours' ||
                               curr.code === 'line-item/trip-price-peak-hours';
    
    // Check if there's a units line item (which should take precedence)
    const hasUnitsLineItem = transaction.attributes.lineItems.some(item => item.code === LINE_ITEM_UNITS);

    // Exclude trip price line items if units line item exists (to avoid double counting)
    if (hasUnitsLineItem && isTripPriceLineItem) {
      return acc;
    }

    if (!excludedLineItems.includes(curr.code)) {
      acc += curr.lineTotal.amount;
    }

    return acc;
  }, 0);

  console.log('Line items breakdown:', transaction.attributes.lineItems.map(item => ({
    code: item.code,
    lineTotal: item.lineTotal.amount,
    included: ![LINE_ITEM_INITIAL_PAYMENT, LINE_ITEM_INITIAL_PAYMENT_PROVIDER, LINE_ITEM_PROVIDER_COMMISSION].includes(item.code)
  })));

  // Add null check to prevent error
  const initialPaymentAmount = initialPayment ? Math.abs(initialPayment) : 0;
  const rawBalance = totalPriceFromLineItems - initialPaymentAmount;
  const totalPrice = isPriceDecreasedForModification ? Math.max(0, rawBalance) : rawBalance;
  console.log('Balance calculation:', {
    totalPriceFromLineItems,
    initialPaymentAmount,
    rawBalance,
    totalPrice,
    isPriceDecreasedForModification,
    modifyTxTotal
  });

  const formattedTotalPrice = formatMoney(intl, new Money(totalPrice, payinTotal.currency));
  console.log('formattedTotalPrice', formattedTotalPrice);

  const modifiedTotal = new Money(totalPriceFromLineItems, payinTotal.currency);

  const modifiedFormattedTotal = formatMoney(intl, modifiedTotal, 2);

  // const initialFormattedTotal = formatMoney(intl, initialPayment, 2);
  const initialFormattedTotal = initialPayment ? (initialPayment/100).toFixed(2) : '';
  console.log('initialFormattedTotal', initialFormattedTotal);
  const initialTotalToPositiveAmount = initialFormattedTotal
    ? initialFormattedTotal.replace('-', '')
    : '';

  return (
    <div className={css.extraDurationChargesRoot}>
      <div>
        <div>
          <div className={css.extraDurationTitle}>Balance due</div>
          {isPriceDecreasedForModification ? (
            <div className={css.extraDurationText}>
              <FormattedMessage
                id="BookingTimeForm.priceDecreasedMessage"
                values={{
                  checkPolicy: (
                    <a
                      href="https://help.drivemate.au/kb/guide/en/drive-mate-trip-extension-policy-XwqgKab0IA/Steps/3997932"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      policy
                    </a>
                  ),
                }}
              />
            </div>
          ) : (
            <div className={css.extraDurationText}>
              Modified price - Original paid ie {modifiedFormattedTotal} -{' '}
              {initialTotalToPositiveAmount}
            </div>
          )}
        </div>
      </div>
      <div className={css.extraDurationValue}>{formattedTotalPrice}</div>
    </div>
  );
};

export default ExtraDurationCharges;
